import { BASE_URL } from "config";
import * as baseApi from "./_base";

export const endpoints = {
    list: `${BASE_URL}/api/v1/agency/`,
    detail: (id) => `${BASE_URL}/api/v1/agency/${id}/`,
};

export const agencyLoad = (token, payload) => baseApi.ListLoad(endpoints.list, token, payload);
export const agencyDetailLoad = (token, { id }) => baseApi.DetailLoad(endpoints.detail, token, { id });
export const agencyUpdate = (token, data) => baseApi.Update(endpoints.list, endpoints.detail, token, data);
export const agencyDelete = (token, { id }) => baseApi.Delete(endpoints.detail, token, { id });
